import { render, staticRenderFns } from "./invite-user.vue?vue&type=template&id=12e9dd50&scoped=true&"
import script from "./invite-user.vue?vue&type=script&lang=js&"
export * from "./invite-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9dd50",
  null
  
)

export default component.exports